// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1dCXh","actionsCol":"EnrolledClinics_actionsCol__go3Rf"};